__turbopack_context__.v({
  "Container": "FormSwitch-module-scss-module__P1SkMG__Container",
  "HelperText": "FormSwitch-module-scss-module__P1SkMG__HelperText",
  "Label": "FormSwitch-module-scss-module__P1SkMG__Label",
  "Switch": "FormSwitch-module-scss-module__P1SkMG__Switch",
  "SwitchWrap": "FormSwitch-module-scss-module__P1SkMG__SwitchWrap",
  "TextContent": "FormSwitch-module-scss-module__P1SkMG__TextContent",
  "Thumb": "FormSwitch-module-scss-module__P1SkMG__Thumb",
  "checkIcon": "FormSwitch-module-scss-module__P1SkMG__checkIcon",
  "closeIcon": "FormSwitch-module-scss-module__P1SkMG__closeIcon",
  "dot": "FormSwitch-module-scss-module__P1SkMG__dot",
  "secondary": "FormSwitch-module-scss-module__P1SkMG__secondary",
});
